import { render } from "./ColumnWidgetModal.vue?vue&type=template&id=65780f0c&scoped=true"
import script from "./ColumnWidgetModal.vue?vue&type=script&lang=ts"
export * from "./ColumnWidgetModal.vue?vue&type=script&lang=ts"

import "./ColumnWidgetModal.vue?vue&type=style&index=0&id=65780f0c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65780f0c"

export default script